"use client";

import { useFormStatus } from "react-dom";
import Spinner from "@/app/components/spinner";
import { Button } from "@urbansportsclub/components/core/Button";

interface FormButtonProps {
  inputVal: string;
  inputError: string | undefined;
  formSubmitting: boolean;
  text: string;
  loadingText: string;
}

export default function SubmitButton({
  inputError,
  inputVal,
  formSubmitting,
  text,
  loadingText,
}: Readonly<FormButtonProps>) {
  const { pending } = useFormStatus();
  const isSubmitting = formSubmitting || pending;

  return (
    <Button
      variant="primary"
      full
      size="normal"
      className={`text-md font-semibold ${isSubmitting ? "bg-blue-respect-700" : ""}`}
      disabled={!inputVal || Boolean(inputError) || isSubmitting}
      type="submit"
    >
      {isSubmitting ? (
        <>
          <Spinner className="mr-3 text-white" />
          {loadingText}
        </>
      ) : (
        text
      )}
    </Button>
  );
}
